import { render, staticRenderFns } from "./potential-detail-modal.vue?vue&type=template&id=7896a4b7&scoped=true"
import script from "./potential-detail-modal.vue?vue&type=script&lang=js"
export * from "./potential-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./potential-detail-modal.vue?vue&type=style&index=0&id=7896a4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896a4b7",
  null
  
)

export default component.exports